import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-chart-exports',
  templateUrl: './chart-exports.component.html',
  styleUrls: ['./chart-exports.component.scss'],
})
export class ChartExportsComponent {}
